import 'vite/modulepreload-polyfill';
import '../../../node_modules/@glidejs/glide/src/assets/sass/glide.core.scss';
import './hero-carousel';
import './media-expand';
import Alpine from 'alpinejs';
import intersect from '@alpinejs/intersect';
import focus from '@alpinejs/focus';
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle'; // import styles bundle
import PredictiveSearchComponent from './component-predictive-search';
import WishlistsComponent from './component-wishlists';
import ProductCardComponent from './product-card';
import FacetFiltersForm from './component-facet-filters-form';
import RangeSlider from './component-range-slider';
import AccountComponent from './account-component';
import StoreMain from './store-main';
import LoadMore from './load-more';
import GridViewSwitcher from './component-grid-view-switcher';
import ShippingEstimator from './shipping-estimator';
import './store-location';

Alpine.plugin(focus);
Alpine.plugin(intersect);
Alpine.store('main', StoreMain);
Alpine.data('facet_filters_form', FacetFiltersForm);
Alpine.data('range_slider', RangeSlider);
Alpine.data('product_card', ProductCardComponent);
Alpine.data('predictive_search', PredictiveSearchComponent);
Alpine.data('account_component', AccountComponent);
Alpine.data('wishlists_component', WishlistsComponent);
Alpine.data('load_more', LoadMore);
Alpine.data('grid_view_switcher', GridViewSwitcher);
Alpine.data('shipping_estimator', ShippingEstimator);

window.Swiper = Swiper;
window.Alpine = Alpine;

Alpine.start();
